import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { Router } from '@angular/router';
import { LocalStorageEnum } from 'src/app/shared/enum.ts/local-storage.enum';
import { LocalStorageService } from './local-storage.service';
import { IUserToken } from 'src/app/shared/models/local-storage';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: ApiHttpService,
    private router: Router,
    private localStorageSerice: LocalStorageService,
  ) {}

  login(body: any) {
    return this.http.post('auth/login', body, {
      withCredentials: true,
    });
  }

  logout() {
    // Call logout API endpoint
    this.http.post('auth/logout', {}).subscribe({
      next: () => {
        // Clear local storage and navigate to login on success
        localStorage.clear();
        this.router.navigate(['/auth/login']);
      },
      error: () => {
        // Even if API call fails, clear local storage and navigate to login
        localStorage.clear();
        this.router.navigate(['/auth/login']);
      },
    });
  }

  setAuthToken(token: string) {
    this.localStorageSerice.setItem(LocalStorageEnum.ACCESS_TOKEN, { access_token: token });
  }

  getAuthToken(): IUserToken {
    return this.localStorageSerice.getItem(LocalStorageEnum.ACCESS_TOKEN);
  }
}
